export const baseUrl =
  process.env.REACT_APP_VERCEL_ENV === "production"
    ? "https://service.edencaremedical.com/demo/api/v1"
    : "https://service.edencaremedical.com/demo/api/v1";
